import React from 'react';
import {Outlet} from 'react-router-dom';

const SessionSearch: React.FC = () => {
  return <Outlet />;
};

export default SessionSearch;
